/**
 * External Dependencies
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

/**
 * Internal Dependencies
 */
import { getNotices } from 'state/notices/selectors';
import { removeNotice } from 'state/notices/actions';
import Notice from 'components/notice';

/**
 * Style dependencies
 */
import './styles.scss';

class GlobalNotices extends Component {
    static defaultProps = {
        notices: [],
    };

    removeReduxNotice = (noticeId, onDismissClick) => {
        return (e) => {
            if (onDismissClick) {
                onDismissClick(e);
            }

            this.props.removeNotice(noticeId);
        };
    };

    render() {
        return (
            <div className={classNames('global-notices', this.props.className)}>
                {this.props.notices.map((notice) => (
                    <Notice
                        onDismissClick={this.removeReduxNotice(notice.noticeId, this.props.onDismissClick)}
                        key={`notice-${notice.id}`}
                        {...notice}
                    >
                        {notice.text}
                    </Notice>
                ))}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    notices: getNotices(state),
});

export default connect(
    mapStateToProps,
    {
        removeNotice,
    },
)(GlobalNotices);
